<template>
  <div class="flex" :class="size">
    <slot name="labelRight">
      <label v-if="labelLocation === 'left'" :for="props.name" class="mr-2" :class="props.classes">{{ label }}</label>
    </slot>
    <slot :value="value">
      <ToggleSwitch v-if="props.switch" v-on:keydown.enter.prevent v-model="value" :inputId="props.name" :disabled="disabled" />
      <Checkbox v-else v-on:keydown.enter.prevent :inputId="props.name" :name="props.name" v-model="value" :binary="true" :disabled="disabled" />
    </slot>
    <slot name="labelLeft">
      <label v-if="labelLocation === 'right'" :for="props.name" class="ml-2" :class="props.classes">{{ label }}</label>
    </slot>
  </div>
</template>

<script setup lang="ts">
const value = defineModel<boolean>({ required: true });

interface Props {
  name: string;
  label: string;
  size?: string;
  classes?: string;
  switch?: boolean;
  disabled?: boolean;
  labelLocation?: "left" | "right";
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  switch: false,
  disabled: false,
  labelLocation: "right",
});
</script>
